import { useMemo } from 'react';

import { getVendors } from '@/helpers/session';
import { Page, usePermissions } from '@/permissions';

import type { MenuRestaurant } from '../types';

type UseMenuRestaurants = {
  restaurants: MenuRestaurant[];
  loading: boolean;
};

export const useMenuRestaurants = (): UseMenuRestaurants => {
  const { vendorIdsFor, loading } = usePermissions();

  // Stable key so the filter only recomputes when the permitted set changes.
  const permittedKey = [...vendorIdsFor(Page.Menus)].sort().join(',');

  const restaurants = useMemo<MenuRestaurant[]>(() => {
    const permitted = new Set(permittedKey ? permittedKey.split(',') : []);
    return (getVendors() as MenuRestaurant[]).filter((vendor) => permitted.has(vendor.id));
  }, [permittedKey]);

  return { restaurants, loading };
};
